const initialState = {
    distanceTotal: null,
};

const calculateTotal = (state = initialState, action) => {
    switch (action.type) {
        case 'CALCULATE_DISTANCE':
            return action.payload.data.data
        default:
            return state
    }
}

export default calculateTotal;